const VIPRedemptionStatus = {
  Pending: "pending",
  Success: "success",
  Failed: "failed",
  Expired: "expired",
};

export default VIPRedemptionStatus;
